module.exports = __webpack_public_path__ + "static/media/logo-color.c0df2e74.png";